import {
  TOGGLE_USER_SHOULD_REFRESH,
  TOGGLE_USER_LOADING,
} from "../actions/user";
import genObj from "../../lib/genObj";

const initialState = {
  shouldRefresh: false,
  loading: true,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_USER_SHOULD_REFRESH:
      return genObj({ ...state, shouldRefresh: action.shouldRefresh });
    case TOGGLE_USER_LOADING:
      return genObj({ ...state, loading: action.loading });
    default:
      return state;
  }
};
export default user;
